<template>
  <div class="scroll-fire-fox cluster-scroll">
    <div class="cluster-hp-div">
      <div class="cluster-hp-title">{{ $tc("Detail", 2) }}</div>
      <div class="cluster-hp-label">
        {{ $t("MaxHP") }}: {{ countHPs }}/{{ maxHPs }}
      </div>
    </div>

    <div class="cluster-hp-div">
      <label class="cluster-hp-title">
        {{ $t("configuration") }}
      </label>
      <div class="automatic-pathway-creation-fields-container">
        <div class="cluster-hp-div">
          <div>
            <v-checkbox
              v-model="fields.filter_bd_include"
              :label="$i18n.t('BuildingsIncludedOnly')"
              color="accent"
              class="multi-selection-checkbox"
              :ripple="false"
            />
          </div>
        </div>
      </div>
    </div>

    <div class="cluster-hp-div">
      <label class="cluster-hp-title">
        {{ $t("AutomaticCableCreation") }}
      </label>
      <div class="automatic-pathway-creation-fields-container">
        <div class="cluster-hp-div">
          <label class="required" for="ownerCable">
            {{ $tc("Owner", 1) }}
          </label>
          <div>
            <treeselect
              v-model="fields.cable_owner"
              :options="ownersOptions"
              :load-options="loadOwnerOptions"
              :normalizer="normalizerList"
              required
              instanceId="ownerCable"
            />
          </div>
        </div>

        <div class="cluster-hp-div">
          <label class="required" for="materialReferenceCable">
            {{ $t("MaterialReference") }}
          </label>
          <div>
            <treeselect
              v-model="fields.cable_material_reference"
              :options="materialCableOptions"
              :load-options="loadMaterialCableOptions"
              :normalizer="normalizerMaterial"
              required
              instanceId="materialReferenceCable"
            />
          </div>
        </div>

        <div class="cluster-hp-div">
          <label for="maxCableLength">
            {{ $t("MaxCableLength") }}
          </label>
          <div>
            <input
              class="automatic-pathway-creation-input-field"
              id="maxCableLength"
              type="number"
              value="maxCableLength"
              v-model="cableDistance"
              @input="
                $emit('changeValue', {
                  prop: 'maxCableLength',
                  value: cableDistance
                })
              "
              :min="0"
            />
            <span> m</span>
          </div>
        </div>
      </div>
    </div>

    <div class="cluster-hp-div">
      <label class="cluster-hp-title">
        {{ $t("AutomaticPathwayCreation") }}
      </label>
      <div class="automatic-pathway-creation-fields-container">
        <div class="cluster-hp-div">
          <div>
            <v-checkbox
              v-model="fields.filter_pathways_with_ignore"
              :label="$i18n.t('DontUsePathwaysIgnored')"
              color="accent"
              class="multi-selection-checkbox"
              :ripple="false"
            />
          </div>
        </div>

        <div class="cluster-hp-div">
          <label class="required" for="ownerPathway">
            {{ $tc("Owner", 1) }}
          </label>
          <div>
            <treeselect
              v-model="fields.pathway_owner"
              :options="ownersOptions"
              :load-options="loadOwnerOptions"
              :normalizer="normalizerList"
              required
              instanceId="ownerPathway"
            />
          </div>
        </div>

        <div class="cluster-hp-div">
          <label class="required" for="typePathway">
            {{ $t("PathwayType") }}
          </label>
          <div>
            <treeselect
              v-model="fields.pathway_type"
              :options="pathwayTypeOptions"
              :load-options="loadPathwayTypeOptions"
              :normalizer="normalizerList"
              required
              instanceId="typePathway"
            />
          </div>
        </div>

        <div class="cluster-hp-div">
          <label for="materialReferencePathway">
            {{ $t("MaterialReference") }}
          </label>
          <div>
            <treeselect
              v-model="fields.pathway_material_reference"
              :options="materialPathwayOptions"
              :load-options="loadMaterialPathwayOptions"
              :normalizer="normalizerMaterial"
              instanceId="materialReferencePathway"
            />
          </div>
        </div>

        <div class="cluster-hp-div">
          <label for="maxPathwayDist">
            {{ $t("MaxPathwayDistance") }}
          </label>
          <div>
            <input
              class="automatic-pathway-creation-input-field"
              id="maxPathwayDist"
              type="number"
              value="maxPathwayDistance"
              v-model="pathwayDistance"
              @input="
                $emit('changeValue', {
                  prop: 'maxPathwayDistance',
                  value: pathwayDistance
                })
              "
              :min="0"
            />
            <span> m</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { clusterOptionsMixin } from "@/mixins/clusterOptionsMixin.js";

export default {
  name: "ClusterFieldsCreate",

  mixins: [clusterOptionsMixin],

  props: {
    maxPathwayDistance: {
      required: true
    },

    maxCableLength: {
      required: true
    },

    clusterWKT: {
      required: true,
      type: Array
    },

    fields: {
      type: Object,
      required: true
    }
  },

  data() {
    return {
      ownersOptions: null,
      materialCableOptions: null,
      pathwayTypeOptions: null,
      materialPathwayOptions: null,
      pathwayDistance: 0,
      cableDistance: 0
    };
  },

  mounted() {
    this.pathwayDistance = this.maxPathwayDistance;
    this.cableDistance = this.maxCableLength;
  },

  computed: {
    countHPs() {
      let hps = 0;
      this.clusterWKT.forEach(building => {
        if (building.type === "Building") {
          hps += building.max_hp;
        }
      });
      return hps;
    },

    maxHPs() {
      let maxHP = 0;
      let closure = this.clusterWKT.find(object => object.type === "Closure");
      if (closure && closure.maxHP) {
        maxHP = closure.maxHP;
      }
      return maxHP;
    }
  }
};
</script>

<style scoped>
.cluster-hp-div {
  padding: 8px 10px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
}

.cluster-hp-title {
  height: 16px;
  color: #acacae;
  font-size: 10px;
  font-weight: 300;
  letter-spacing: 0.02px;
  line-height: 16px;
  text-align: left;
  margin-bottom: 4px;
  text-transform: uppercase;
}

.cluster-hp-label {
  height: 16px;
  width: 100%;
  color: #515358;
  font-size: 12px;
  font-weight: 300;
  letter-spacing: 0.02px;
  line-height: 16px;
  text-align: left;
}

.cluster-scroll {
  overflow: auto;
  scroll-behavior: smooth;
  max-height: 300px;
}

.automatic-pathway-creation-fields-container {
  width: 100%;
  border: 1px solid lightgray;
  border-radius: 2px;
}

.automatic-pathway-creation-input-field {
  border: 1px solid lightgrey;
  padding: 2px 4px;
  width: 50px;
}

.required:after {
  margin-left: 2px;
  color: #88898c;
  content: "*";
  font-size: 11px;
  display: inline;
  font-weight: 500;
}
</style>



// WEBPACK FOOTER //
// src/components/Home/Content/ObjectWindow/Cluster/ClusterFieldsCreate.vue